import axios from 'axios'

export default {
    list() {
        return axios.get('/checkbox-logins')
    },
    get(id) {
        return axios.get(`/checkbox-logins/${id}`)
    },
    create(data) {
        return axios.post('/checkbox-logins', data)
    },
    update(id, data) {
        return axios.put(`/checkbox-logins/${id}`, data)
    },
    remove(id) {
        return axios.delete(`/checkbox-logins/${id}`)
    }
}